module.exports = __webpack_public_path__ + "media/Conclave Tut.3cafd9e8.mp4";